import React, { useState } from 'react'

import AdminRepairEntryNew from './AdminRepairEntryNew';

const repairEntryDefault = {
  StockKeepingUnit: "",
  LotNumber: "",
  ItemCode: "",
  MakingFixedAmt: 0,
  MakingPerGram: 0,
  MakingFixedWastage: 0,
  MakingPercentage: 0,
  MetalRate: 0,
  FinePercent: 0,
  WastagePercent: 0,
  Quantity: 1,
  PurityId: 0,
  CategoryId: 0,
  ProductId: 0,
  DesignId: 0,
  FineGoldWt: 0,
  FineSilverWt: 0,
  TotalFineGold: "",
  FineOtherMetalWt: 0,
  TotalStoneAmt: 0,
  TotalItemAmt: 0,
  FineWt: 0,
  WastageWt: 0,
  FineWastageWt: 0,
  RDPurchaseId: 0,
  CategoryName: "",
  ProductName: "",
  DesignName: "",
  GrossWt: 0,
  NetWt: 0,
  StoneWt: 0,
  Status: "Active",
  CounterId: 0,
  BranchId: 0,
  CompanyId: 0,
  FinePure: false,
  ClientCode: 0,
  AddToUnlabelled: false,
  MetalId: 0,
  MetalName: "",
  StoneName: "",
  StoneWeight: 0,
  StonePieces: 0,
  StoneRate: 0,
  StoneAmount: 0,
  HallmarkAmt: 0,
  TagWeight: 0,
  FindingWeight: 0,
  LanyardWeight: 0,
  Testing: "0",
  Stones: [],
  Diamonds: [],
  ConvertAmount: true,
  MRP: "0",
  ClipWeight: "0",
  ClipQuantity: "0",
  DiamondName: "",
  DiamondWeight: 0,
  DiamondRate: 0,
  DiamondPieces: 0,
  DiamondAmount: 0,
  DiamondSize: "0",
  DiamondPurchaseRate: "0",
  DiamondSellRate: "0",
  DiamondClarity: "",
  DiamondColour: "",
  DiamondShape: "",
  DiamondCut: "",
  DiamondSettingType: "",
  DiamondCertificate: "",
  DiamondPurchaseAmount: "0",
  DiamondSellAmount: "0",
  DiamondDescription: "",
  status: "paid",
  skus: [],
  paymentTypes: [],
  balanceGold: "",
  taxableAmount: "",
  gst: "",
  paidAmount: "",
  advanceAmount: "",
  balanceSilver: "",
  RODiscount: "",
  totalAmount: "",
  balanceAmount: "",
  // invoiceNumber:"",
  // VendorName:"",
  invoiceDate: new Date().toISOString().split("T")[0],
};
const AdminRepairEntry = () => {
  const [editStatus,setEditStatus] = useState(false)

  return (
   <AdminRepairEntryNew
   editStatus={editStatus}
   defaultValues={repairEntryDefault}
   />
  )
}

export default AdminRepairEntry
